// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-add-edit-recommendation').AddRecommendation

      resolve(View)

    /* Webpack named bundle   */
    }, 'addRecommendation')
  })
}

export default asyncRoute({getComponent, reducers: []})
